// extracted by mini-css-extract-plugin
module.exports = {"tabsContent":"Tabs_tabsContent__qv51P","tabsContainer":"Tabs_tabsContainer__1WA7D","buttonContainer":"Tabs_buttonContainer__2xC34"};